module.exports = __webpack_public_path__ + "static/media/20.453ed56c.jpg";